import { Box, Button, Link } from '@mui/material';
import React from 'react';
import filterStore from '../stores/filterStore';
import logger from '../utils/logger';
import { FaWhatsapp } from "react-icons/fa";
import { RiTelegram2Line } from "react-icons/ri";

function DashboardPage() {
  return (
    <>
      <Box className='mt-5 font-semibold text-xl ml-2 max-w-3xl text-left'>
       <p> Добро пожаловать в Reldo CRM! 🎉 </p>
	   <br />
	   	<p className='text-lg'> Этот Дашборд пока пустой, но скоро здесь появится вся важная информация. Самое главное уже работает: вы можете управлять Заявками, Объектами и Коллегами. </p>
          <br />
       <p className='text-lg'> Переходите в эти разделы через меню (☰ вверху слева) </p>

       <p className='text-lg mt-8'>Если у вас возникли трудности, пожалуйста, обратитесь в техподдержку</p>

       <Box>
					<Link 
						href="https://wa.me/79882602218" 
						target="_blank" 
						rel="noopener noreferrer"
						sx={{ 
							textDecoration: 'none', 
							color: '#25D366', 
							fontWeight: 'bold',
							display: 'flex',
							alignItems: 'center',
							gap: '5px',
							mb: 1
						}}
					>
						<FaWhatsapp style={{ fontSize: '18px' }} /> +7988-260-22-18
					</Link>
					<Link 
						href="https://t.me/reldo_crm" 
						target="_blank" 
						rel="noopener noreferrer"
						sx={{ 
							textDecoration: 'none', 
							color: '#0088cc', 
							fontWeight: 'bold',
							display: 'flex',
							alignItems: 'center',
							gap: '5px' 
						}}
					>
						<RiTelegram2Line style={{ fontSize: '18px' }} /> @reldo_crm
					</Link>
          <p className='mt-8'>Также подписывайтесь на наш канал в Telegram, где мы будем делиться новостями и обновлениями</p>
       
        <a 
            href="https://t.me/reldo_news" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ 
              textDecoration: 'none', 
              color: '#0088cc', 
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              gap: '5px'
            }}  
          >
            <RiTelegram2Line style={{ fontSize: '20px' }} /> @reldo_news
          </a>
        
				</Box>
      </Box>
    </>
  );
}

export default DashboardPage;
